import { Icon, Modal, Text } from '@ui/themed';
import { t } from 'i18next';
import { Trans } from 'react-i18next';
import { useEnv } from '../../../../context/env-context';
import { useHandlers, useSite } from '../../../../context/page-context';
import { trackUpgradeClicked } from '../../../../lib/mixpanel';
import { useAvailablePlans } from '../../../billing/hooks/use-available-plans';

export function UpgradePlanModal({
  isOpen,
  closeModal,
}: {
  isOpen: boolean;
  closeModal: () => void;
}) {
  const env = useEnv();
  const { navigationHandler } = useHandlers();
  const { data: plans } = useAvailablePlans();
  const site = useSite();

  const starterPlan = plans?.find((plan) => plan.planKey === 'v2_basic');
  const price = starterPlan?.price != null ? `$${starterPlan.price}` : undefined;
  const maxPriceLists = env.billing.max_price_lists;

  const goToPlanPage = () => {
    closeModal();
    trackUpgradeClicked(site, 'Price Lists');
    navigationHandler.navigateById('plan', {
      excludeSiteEnv: true,
      excludeSiteId: true,
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={closeModal}
      primaryAction={{
        text: t('price_lists.modals.upgrade_plan.cta', {
          price,
        }),
        onClick: goToPlanPage,
      }}
      secondaryAction={{
        text: t('price_lists.modals.upgrade_plan.compare_plans'),
        onClick: goToPlanPage,
      }}
    >
      <Modal.Header>{t('price_lists.modals.upgrade_plan.heading')}</Modal.Header>
      <Modal.Body>
        <div className="flex flex-col gap-4">
          <Text variant="primary" size="md">
            {t('price_lists.modals.upgrade_plan.body', { maxPriceLists })}
          </Text>

          <Text variant="primary" size="md">
            {t('price_lists.modals.upgrade_plan.features_heading')}
          </Text>

          <ul className="flex flex-col gap-2">
            {(
              [
                'unlimited_price_lists',
                'sales_agent_portal',
                'orders_per_month',
                'discount_engine',
                'personalised_onboarding',
              ] as const
            ).map((feature) => (
              <li key={feature} className="flex items-start gap-2">
                <Icon name="check" size="sm" />
                <span>
                  <Trans i18nKey={`price_lists.modals.upgrade_plan.features.${feature}`} />
                </span>
              </li>
            ))}
          </ul>
        </div>
      </Modal.Body>
    </Modal>
  );
}
